import '../js/InteractiveMap';
import './response-time-mount';
